import React, { useEffect, useState, useRef } from "react";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import { faEdit, faEye, faDeleteLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AddCheckListLawsuitQst from "./addCheckListLawsuitQst";
const MySwal = withReactContent(Swal2);

const AdminPanelChecklistLawsuit = (props) => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showEditId, setShowEditId] = useState("");

  const fetchResults = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getCheckOptionsLawsuit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setQuestions(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchResults();
  };

  useEffect(() => {
    getData();
  }, []);

  const closeAdd = () => {
    setShowAdd(false);
    getData();
  };

  const closeEdit = () => {
    setShowEdit(false);
    getData();
  };

  const deleteCheck = async (e) => {
    var body = {
      id: e.currentTarget.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteCheckOptionsLawsuit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Usunięto",
          text: "pytanie",
        }).then(async (result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  const usersTableFirst = (
    <table id="detailClientTable" className="clients_table">
      <tr>
        <th>Lp.</th>
        <th>Pytanie</th>
        <th>Rodzaj</th>
        <th>Opcje odpowiedzi</th>
        <th>Akcja</th>
      </tr>
      {questions.map((el, index) => (
        <>
          <tr>
            <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
              {index + 1}
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              {el.question}
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              {el.type === "text"
                ? "Tekst"
                : el.type === "select"
                ? "Lista rozwijania"
                : el.type === "checkbox"
                ? "Checkbox"
                : ""}
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              {el.type === "checkbox"
                ? "PRAWDA/FAŁSZ"
                : el.type === "text"
                ? "OTWARTY TEKST"
                : el.type === "select"
                ? el.options
                : ""}
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value={el.id}
                onClick={(e) => {
                  setShowEdit(true);
                  setShowEditId(e.currentTarget.value);
                }}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value={el.id}
                onClick={deleteCheck}
              >
                <FontAwesomeIcon icon={faDeleteLeft} />
              </button>
            </td>
          </tr>
        </>
      ))}
    </table>
  );

  return (
    <>
      <div className="mainContainerPayments">
        {loading ? (
          <>
            <LoadingPopup />
          </>
        ) : (
          <>
            {showAdd ? <AddCheckListLawsuitQst close={closeAdd} /> : ""}
            {showEdit ? (
              <AddCheckListLawsuitQst
                close={closeEdit}
                qst={questions.filter((el) => +el.id === +showEditId)[0]}
                mode={"edit"}
              />
            ) : (
              ""
            )}
            <div
              style={{ width: "100%", marginBottom: "1vh" }}
              className="closeBox"
            >
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            <div
              style={{
                height: "5vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Pytania w ankiecie do pozwu
            </div>
            {usersTableFirst}
            <button
              style={{ marginTop: "2vh", backgroundColor: "green" }}
              className="closeClientButton"
              onClick={() => setShowAdd(true)}
            >
              DODAJ
            </button>
          </>
        )}
      </div>
    </>
  );
};

export default AdminPanelChecklistLawsuit;
